module.exports = __webpack_public_path__ + "static/media/ic-right-blue.75a5ea1b.svg";